import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId, DateConvertInDbFormat } from "../../Base/helper/baseFunctions";
import NProgress from "nprogress";
import { validateEmailHelper } from "../../SignIn/helper/SigninHelper";


export const GetExistingEmployeesHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/user/getExistingEmployees`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            ats_work_location_json: params?.ats_work_location_json || null,
            user_id: getUserId()
        }
    })
    .then((res) => {
        NProgress.done()
        return { message: "Employees Retrieved Successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done()
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to fetch Employees", hasError: false, data: err?.response?.data }
    })
}


export const GetEACUserHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/user/getExternalCoreHrUsers`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            status: params?.status,
            user_id: getUserId()
        }
    })
    .then((res) => {
        NProgress.done()
        return { message: "User Created Successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done()
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Failed to Update", hasError: false, data: err?.response?.data }
    })
}


export const AddEACUserHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/user/addCoreHrUser`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_id: params?.employee_id,
            first_name: params?.first_name,
            last_name: params?.last_name || "",
            office_email: params?.office_email,
            wl_id: params?.wl_id || null,
            designation_id: params?.designation_id || null,
            is_active: params?.is_active,
            date_of_birth: params?.date_of_birth || null,
            core_hr_user_type:  params?.core_hr_user_type,
            enable_ats: params?.enable_ats,
            enable_corehr: params?.enable_corehr,
            enable_lms: params?.enable_lms,
            reporting_manager_id: params?.reporting_manager_id || null,
            doj: params?.doj || DateConvertInDbFormat(),
            image: params?.image || null,
            descriptor: params?.descriptorm || null,
            businessunit_fk:  params?.businessunit_fkm || null,
            uan_no: params?.uan_nom || null,
            pan: params?.panm || null,
            previous_employee_id: params?.previous_employee_id || null,
            title: params?.title || "",
            work_hour_configuration_id: params?.work_hour_configuration_id || null,
            whatsapp_phone_no: params?.whatsapp_phone_no || null,
            enable_payroll: params?.enable_payroll || false,
            enable_payroll_executive: params?.enable_payroll_executive || false,
            enable_finance_executive: params?.enable_finance_executive || false,
            enable_visitor_management: params?.enable_visitor_management || false,
            enable_expense_executive: params?.enable_expense_executive || false,
            enable_lms_executive: params?.enable_lms_executive || false,
            custom_empno_flag: params?.custom_empno_flag || false, // false
            employee_no:  params?.employee_no || null,
            enable_settings_access: params?.enable_settings_access || false,
            enable_employee_management: params?.enable_employee_management || false,
            is_external: params?.is_external,
            vm_exec_access: params?.vm_exec_access || false,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("User Created Successfully");
        validateEmailHelper({ domain: getDomain(), email: params?.office_email  })
        return { message: "User Created Successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Failed to Update", hasError: false, data: err?.response?.data }
    })
}

export const UpdateEACUserHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/user/updateExternalCoreHrUsers`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            emp_users_pk: params?.emp_users,
            user_id: getUserId(),
            office_email: params?.office_email,
            core_hr_user_type: params?.core_hr_user_type,
            enable_ats: params?.enable_ats || false,
            enable_corehr: params?.enable_corehr || false,
            enable_lms: params?.enable_lms || false,
            enable_payroll: params?.enable_payroll || false,
            enable_payroll_executive: params?.enable_payroll_executive || false,
            enable_finance_executive: params?.enable_finance_executive || false,
            enable_visitor_management: params?.enable_visitor_management,
            enable_expense_executive: params?.enable_expense_executive || false,
            enable_lms_executive: params?.enable_lms_executive || false,
            worklocation_json: params?.all_locations_access ? params?.ats_work_location_id : null,
            all_locations_access: params?.all_locations_access || false,
            enable_geofencing: params.enable_geofencing || false,
            enable_face_location_restriction: params.enable_face_location_restriction || false,
            enable_settings_access: params.enable_settings_access || false,
            enable_employee_management: params.enable_employee_management || false,
            first_name: params?.first_name,
            last_name: params?.last_name || "",
            whatsapp_phone_no: params?.whatsapp_phone_no,
            gender: params?.gender || "",
            title: params?.title || "",
            vm_exec_access: params?.vm_exec_access || false
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Controls Updated Successfully");
        return { message: "User Created Successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Failed to Update", hasError: false, data: err?.response?.data }
    })
}